export const LOAN_API_PREFIX = '/api/kloans-loan';
